import { ARTICOLI, AUTORI, RACCOLTE, SLUG, STRUMENTI } from '../../utils/endpoint'
import React, { useEffect, useRef, useState } from 'react'

import AutoreSummary from '../../components/AutoreSummary'
import Breadcrumbs from '../../components/atomic/Breadcrumbs'
import Error from 'next/error'
import MetaSeo from '../../components/atomic/MetaSeo'
import { api } from '../../utils'
import BoxSportello from '../../components/atomic/BoxSportello'
import Slider from '../../components/Slider'

const AutoriDetail = React.memo(({ autore, pagina, statusCode }) => {
  if (!autore) return <Error statusCode={statusCode} />

  const [articoli, setArticoli] = useState([])
  const [strumenti, setStrumenti] = useState([])
  const [raccolte, setRaccolte] = useState([])

  const getSliderItems = async () => {
    const params = { utenti__id: autore.id }

    api.get(ARTICOLI, { params }).then(response => setArticoli(response.data.results))
    api.get(STRUMENTI, { params }).then(response => setStrumenti(response.data.results))
    api.get(RACCOLTE, { params }).then(response => setRaccolte(response.data.results))
  }

  useEffect(() => {
    getSliderItems()
  }, [])

  const refs = {
    strumentiSlider: useRef(null),
    articoliSlider: useRef(null),
    raccolteSlider: useRef(null),
  }

  const summaryProps = {
    autore,
    articoli,
    strumenti,
    raccolte,
  }

  const getSliderClass = slider => {
    const slidersMap = { articoli, strumenti, raccolte }

    const slidersBool = Object.values(slidersMap)
      .filter(value => value.length)
      .reduce((reduced, item, i) => {
        item = i ? !reduced[i - 1] : false
        return [...reduced, item]
      }, [])

    let slidersClasses = {}

    Object.keys(slidersMap)
      .filter(key => slidersMap[key].length)
      .forEach((item, index) => {
        slidersClasses[item] = slidersBool[index]
      })

    return slidersClasses[slider] ? 'u-bg-white' : ''
  }

  return autore ? (
    <>
      <MetaSeo seo={pagina.seo} />
      <main className={`autore-page`}>
        <header className="autore-page__header">
          <div className="w-container">
            <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
            <div className={autore.esperto ? 'col' : 'col u-before-section'}>
              <AutoreSummary {...summaryProps} ref={refs} />
            </div>
          </div>
        </header>

        {autore.esperto && autore.paginafaq && (
          <div className="w-container">
            <BoxSportello autore={autore} detail />
          </div>
        )}

        {articoli.length || strumenti.length || raccolte.length ? (
          <div className="u-before-section" />
        ) : null}

        {articoli.length ? (
          <>
            <div ref={refs.articoliSlider} />
            <Slider
              items={articoli}
              classes={`u-before-section ${getSliderClass('articoli')}`}
              titolo="Lezioni e Articoli"
              type="articolo"
            />
          </>
        ) : null}

        {strumenti.length ? (
          <>
            <div ref={refs.strumentiSlider} />
            <Slider
              items={strumenti}
              classes={`u-before-section ${getSliderClass('strumenti')}`}
              titolo="Materiali"
              type="strumento"
            />
          </>
        ) : null}

        {raccolte.length ? (
          <>
            <div ref={refs.raccolteSlider} />
            <Slider
              items={raccolte}
              classes={`${getSliderClass('raccolte')}`}
              titolo="Raccolte"
              type="raccolta"
            />
          </>
        ) : null}
      </main>
    </>
  ) : null
})

export const getServerSideProps = async ({ query: { slug }, res, req }) => {
  const headers = req?.headers?.cookie
    ? { cookie: req.headers.cookie, anteprima: req.headers.anteprima || false }
    : undefined

  try {
    const response = await api.get(`${AUTORI}${SLUG}${slug}/`, { headers })
    const autore = response.data

    const pagina = autore.pagina

    const toolbarProps = { toolbarPage: pagina, toolbarItem: autore }

    return { props: { autore, pagina, key: autore.id, ...toolbarProps } }
  } catch (error) {
    if (res) {
      res.statusCode = 404
    }
    return { props: { statusCode: 404 } }
  }
}

export default AutoriDetail
